export default __webpack_public_path__ + "static/25-96cd45b0731d7c478a1fb5a0740879ca.webp";